import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;

export class transactionsPaymentSummaryPrintable_template extends vnTemplate{

    public validationsList: validationsList_template;

    protected getTemplateHtml(): string{

        return `
            <div>` + this.validationsList.getHtmlBuild() + `</div>
            <div class="w-slip-list" id="list-results" data-bind="foreach: users">
     
                <div class="slip-header">
                    <div>
                        <strong data-bind="text: user_fullName"></strong><br />
                        Currency: <strong data-bind="text: currency"></strong><br />
                        Payment Date: <strong data-bind="text: payment_date"></strong>
                    </div>
                </div>
                
                <table class="slip-list">
                    <thead>                               
                        <tr>
                            <th><span>Entry</span></th>
                            <th><span>Article Title</span></th>
                            <th><span>Date Creation</span></th>
                            <th><span>Amount</span></th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <td colspan="3"></td>
                            <td class="align-right">
                                <span class="split-total-title">Total:</span>
                            </td>
                            <td class="align-right">
                                <span class="split-total-value" data-bind="text: total"></span>
                            </td>
                        </tr>
                    </tfoot>
                    <tbody data-bind="foreach: transactions">
                        <tr>
                            <td><span data-bind="text: entry_type"></span></td>
                            <td class="description left-align"><span data-bind="text: item.title"></span></td>
                            <td class="dateCreation"><span data-bind="text: dateCreation"></span></td>
                            <td class="amount align-right"><span data-bind="text: amount"></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    public setUsers(users){
        this.getTemplateViewModel().users(users);
    }

    public setPayments(payments){
        this.getTemplateViewModel().payments(payments);
    }


    protected getTemplateName(): string{
        return "transactionsPaymentSummaryPrintable-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
            users: ko.observableArray([])
            ,idPayment: ko.observable("")
            ,payments: ko.observable([])
            ,brand: ko.observable({})
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
        };
    }

    public onChangeFilterAction(data) {

        this.caller.filterSimpleOnChange();
    }



}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsPaymentSummaryPrintable_template.ts